import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, WMS_MODULE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ProductAttributesList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.string, show: false, width: 80 },
			{
				Header: 'attributeName',
				accessor: 'attributeName',
				filterType: FilterType.string,
				width: 120,
				showOnMobile: true
			},
			{ Header: 'attributeLabel', accessor: 'attributeLabel', filterType: FilterType.string, width: 100 },
			{
				Header: 'type',
				accessor: 'type',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.PRODUCT_ATTRIBUTE_TYPES
			},
			{ Header: 'groupName', accessor: 'groupName', filterType: FilterType.multiSelection },
			{ Header: 'description', accessor: 'description', filterType: FilterType.string, width: 100 },
			{
				Header: 'showOnImport',
				accessor: 'showOnImport',
				filterType: FilterType.enum,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS
			},
			{ Header: 'defaultValue', accessor: 'defaultValue', filterType: FilterType.string, width: 100 }
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.PRODUCT_ATTRIBUTES}
				columns={columns}
				fetchUrl={WMS_MODULE.GET_PRODUCT_ATTRIBUTES_LIST}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.PRODUCT_ATTRIBUTES}
				exportName="product-attributes"
			/>
		</TabTableContainer>
	);
};

export default ProductAttributesList;
